import { render, staticRenderFns } from "./CartaoInformacoesAtendimento.vue?vue&type=template&id=0dee5136&scoped=true"
import script from "./CartaoInformacoesAtendimento.vue?vue&type=script&lang=js"
export * from "./CartaoInformacoesAtendimento.vue?vue&type=script&lang=js"
import style0 from "./CartaoInformacoesAtendimento.vue?vue&type=style&index=0&id=0dee5136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dee5136",
  null
  
)

export default component.exports